module.exports = __webpack_public_path__ + "static/media/Hudson-soffa-detalj-a-miljö-2021.1ad31926.jpg";